<template>
    <CustomSelectOne v-if="!loading" :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="label" :item-value="itemValue" :label="label" :required="required"
                     :noPlaceholder="noPlaceholder" :rules="rules"/>
</template>

<script>
import CustomSelectOne from "./inner/CustomSelectOne";
import {getSemenTypesEnum} from "@/swagger/vue-api-client";

export default {
    name: "CustomSelectOneSemenType",
    components: {CustomSelectOne},

    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        emptyValue: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: null,
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
        itemValue: {
            type: String,
            default: "value",
        },
        rules: undefined,
    },

    emits: ["update:modelValue"],

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },

    data() {
        return {
            loading: false,
            items: [],
        };
    },

    beforeMount() {
        this.loading = true;
        getSemenTypesEnum().then((response) => {
            this.items = response.data;
            this.loading = false;
        });
    },
};
</script>

<style scoped>
</style>
